import React, { useState, useRef, useLayoutEffect, useEffect } from 'react';

const AILegalityBadge = ({ status, reason, isOpen, onToggle }) => {
    const badgeRef = useRef(null);
    const popoverRef = useRef(null); // New Ref for the popup content
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    // Calculates the exact position
    useLayoutEffect(() => {
        if (isOpen && badgeRef.current) {
            const rect = badgeRef.current.getBoundingClientRect();
            setCoords({
                top: rect.bottom + 5,
                left: rect.left
            });
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;

        const handleClose = () => onToggle();

        // Naya Scroll Handler
        const handleScroll = (event) => {
            if (popoverRef.current && popoverRef.current.contains(event.target)) {
                return; 
            }
            handleClose();
        };

        const handleClickOutside = (event) => {
            if (
                (badgeRef.current && badgeRef.current.contains(event.target)) ||
                (popoverRef.current && popoverRef.current.contains(event.target))
            ) {
                return;
            }
            handleClose();
        };

        window.addEventListener('scroll', handleScroll, true); 
        window.addEventListener('resize', handleClose);
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            window.removeEventListener('scroll', handleScroll, true);
            window.removeEventListener('resize', handleClose);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onToggle]);

    let badgeClass = "ev-btn-xsmall ev-bold-med ev-radius-xlarge cursor-pointer d-inline-flex justify-content-center align-items-center margin-top-5 ";
    let label = "Unknown";

    if (status === 'applicable') {
        badgeClass += "ev-alert-card-success";
        label = "AI USE";
    } else if (status === 'not_applicable') {
        badgeClass += "ev-alert-card-danger";
        label = "No AI USE";
    } else {
        badgeClass += "ev-alert-card-warn";
        label = "Unknown";
    }

    return (
        <>
            {/* The Badge Button */}
            <span
                ref={badgeRef}
                className={badgeClass}
                style={{ width: '60px' }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onToggle();
                }}
            >
                {label}
                
            </span>

            {/* The Popover */}
            {isOpen && (
                <div
                    ref={popoverRef} // Ref attached here
                    className="ev-message-card2 ev-card-3 w-15 position-fixed"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        top: `${coords.top}px`,
                        left: `${coords.left}px`,
                        width: 'var(--px-250)',
                        zIndex: 9999,
                        cursor: 'default',
                        margin: 0
                    }}
                >
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center margin-bottom-10">
                        <strong className="ev-xsmall-p-blue text-uppercase">Reason</strong>
                        <i
                            className="bi bi-x cursor-pointer ev-med-p-dark"
                            onClick={(e) => { e.stopPropagation(); onToggle(); }}
                        ></i>
                    </div>

                    {/* Content */}
                    <div className="scrollable-element vh-10">
                        <p className="ev-small-p-dark mb-0 text-start">
                            {reason || "No details provided."}
                        </p>
                    </div>

                </div>
            )}
        </>
    );
};

export default AILegalityBadge;